import withModule from './ModuleComponent';

export default class Component<P = {}, S = {}> extends withModule(false)<P, S> {}
// export default class Component<P, S> extends withModule(false)<P, S> {}
